import { useState } from "react";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { SelectItem } from "./select-item";

export type SelectOption = {
    value: string;
    label: string;
};

export function SearchSelect({
    title,
    placeholder,
    value,
    onSearch,
    onChange,
    error,
}: {
    title: string;
    placeholder: string;
    value: string | undefined;
    onSearch: (search: string) => Promise<SelectOption[]>;
    onChange: (selection: string) => void;
    error: string | undefined;
}) {
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };
    const hideDropdown = () => {
        setTimeout(function () {
            // Delay for 0.2 to allow selection.
            setShowDropdown(false);
        }, 200);
    };

    const [search, setSearch] = useState<string>("");
    const [options, setOptions] = useState<SelectOption[]>([]);
    const handleSearch = async (newSearch: string) => {
        setSearch(newSearch);
        setOptions(await onSearch(newSearch));
    };

    const handleSelect = (selection: string) => {
        value = selection;
        hideDropdown();
        onChange(selection);
    };

    return (
        <fieldset className="fieldset mb-0">
            <legend className="fieldset-legend text-xs font-medium text-gray-600">
                {title}
            </legend>
            <div className="relative" onBlur={hideDropdown}>
                {showDropdown ? (
                    <div className="absolute z-100 top-10 w-full rounded-md bg-white border-1 border-gray-200 shadow-sm ">
                        <div className="flex items-center gap-2 border-b p-2">
                            <FaMagnifyingGlass className="w-3 h-3 text-gray-400" />
                            <input
                                autoFocus={true}
                                type="search"
                                placeholder="Search..."
                                className="w-full rounded-md bg-transparent py-1 text-sm outline-none"
                                value={search}
                                onChange={(e) => {
                                    e.preventDefault();
                                    handleSearch(e.target.value);
                                }}
                            />
                        </div>

                        <ul className="menu dropdown-content w-full max-h-50 border-b flex flex-col flex-nowrap overflow-y-auto">
                            {options.map((o) => {
                                return (
                                    <SelectItem
                                        key={o.value}
                                        value={o.value}
                                        label={o.label}
                                        currentlySelected={value}
                                        handleSelect={handleSelect}
                                    />
                                );
                            })}
                            {search.length > 0 && options.length == 0 ? (
                                <SelectItem
                                    key={search}
                                    value={search}
                                    label={search}
                                    currentlySelected={value}
                                    handleSelect={handleSelect}
                                />
                            ) : (
                                ""
                            )}
                        </ul>
                    </div>
                ) : (
                    ""
                )}
                <div
                    className="input input-bordered input-sm w-full pl-3 pr-1"
                    onClick={toggleDropdown}
                >
                    {value ? (
                        <span>{value}</span>
                    ) : (
                        <span className="text-gray-400">{placeholder}</span>
                    )}
                </div>
            </div>
            <p className="text-red-600 text-xs">{error}</p>
        </fieldset>
    );
}
